import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMondialRelay = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 32,
		height: 32,
		rx: 16,
		fill: "#96154A"
	}), /* @__PURE__ */ _jsxs("g", {
		transform: "translate(7 7) scale(0.098603) translate(-109.649 -82.809)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M211.6,168.71c-21.1-3.76-35.15,7.52-35.15,25.84v44.44l-33.14,22.86v-67.33c0-36.58,25.36-62.14,68.3-56.88v31.08h0Z",
				fill: "#fff"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M200.42,105.31c0,3.75-1.12,7.43-3.21,10.56-2.09,3.13-5.06,5.56-8.55,7-3.48,1.43-7.3,1.81-11,1.09-3.7-.74-7.08-2.54-9.75-5.2-2.66-2.66-4.47-6.05-5.21-9.73-.74-3.69-.36-7.51,1.09-10.98,1.44-3.48,3.88-6.43,7.01-8.53,3.13-2.09,6.81-3.2,10.58-3.2,2.5,0,4.98.49,7.29,1.44s4.41,2.35,6.18,4.11c1.77,1.76,3.17,3.86,4.12,6.17s1.44,4.78,1.44,7.27",
				fill: "#fff"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M258.54,165.39c-.05,1.16-.47,2.26-1.2,3.16-.73.9-1.72,1.53-2.85,1.81-9.19,1.62-18.61,1.62-27.81,0-1.12-.29-2.11-.93-2.85-1.81-.73-.9-1.15-2-1.2-3.15v-24.41c.05-1.16.47-2.26,1.2-3.16.73-.9,1.72-1.53,2.85-1.81,9.19-1.62,18.61-1.62,27.81,0,1.12.29,2.12.92,2.85,1.81.73.9,1.15,2,1.2,3.16v24.41h0Z",
				fill: "#fff"
			}),
			/* @__PURE__ */ _jsx("g", {})
		]
	})]
});
export default SvgMondialRelay;
